import moment from 'moment-timezone'

import logger from '~/lib/logger'
import { TrackIdentifyData } from '~/lib/analytics/actions/identify'

import createProxy from './createScriptProxy'

export default class AppcuesApi {
    appId?: string | null
    api: ((event: string, ...args: any[]) => void) | null = null
    isConstructed?: boolean

    constructor({ appId = null }: { appId?: string | null }) {
        this.appId = appId

        if (!this.appId || this.isConstructed) {
            return
        }

        const proxy = createProxy({
            scriptUrl: `https://fast.appcues.com/${this.appId}.js`,
            globalName: 'Appcues',
            tagId: null,
        })

        this.api = function api(method: any, ...args: any) {
            proxy(method, ...args).catch(e => logger.exception(e))
        }

        this.isConstructed = true
    }

    // https://docs.appcues.com/article/161-javascript-api
    identify(userId: number, traits: TrackIdentifyData['traits']) {
        this.api?.('identify', userId, {
            ...traits,
            createdAt: moment(traits.createdAt).unix(),
            isTeamsEnabled:
                traits?.businessAccountMembership?.businessAccount
                    ?.isTeamsFeatureEnabled || false,
            isInATeam: traits?.teams?.items?.length > 0,
            workspaceCount:
                traits?.businessAccountMembership?.businessAccount
                    ?.totalTeams ?? 0,
        })
    }

    track(eventName: string, data: any) {
        this.api?.('track', eventName, data)
    }

    page() {
        this.api?.('page')
    }

    anonymous() {
        this.api?.('anonymous')
    }
}
